import { render, staticRenderFns } from "./OrderEmisionVehicleNewRisk.vue?vue&type=template&id=935c594a"
import script from "./OrderEmisionVehicleNewRisk.vue?vue&type=script&lang=js"
export * from "./OrderEmisionVehicleNewRisk.vue?vue&type=script&lang=js"
import style0 from "./OrderEmisionVehicleNewRisk.vue?vue&type=style&index=0&id=935c594a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports